/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Device_Quick_Action_SublineInputs */

const de_device_quick_action_subline = /** @type {(inputs: Device_Quick_Action_SublineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angemeldete Geräte anzeigen und bearbeiten`)
};

/** @type {(inputs: Device_Quick_Action_SublineInputs) => LocalizedString} */
const en_device_quick_action_subline = de_device_quick_action_subline;

/**

* @param {Device_Quick_Action_SublineInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const device_quick_action_subline = /** @type {((inputs?: Device_Quick_Action_SublineInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Device_Quick_Action_SublineInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_device_quick_action_subline(inputs)
	return en_device_quick_action_subline(inputs)
});